export default "__VITE_ASSET__Bp9Gt_Wj__"